module.exports = __webpack_public_path__ + "img/qianbao.01d30149.png";